import { __rest } from "tslib";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { Observable } from "rxjs/Observable";
import { getErrorMessage } from "./errorParser";
export function createActionDuck(namespace, computeActionUrl, computeActionId, computeBodyContent = (payload) => payload) {
    const { actions, reducer, actionKeys } = createActionsReducer(namespace, computeActionId);
    const selectors = createSelectors(computeActionId);
    const middleware = actionMiddleware(actionKeys, computeActionUrl, computeBodyContent, actions.setResponse, actions.setError, actions.setPending);
    return { actions, reducer, selectors, middleware, ActionKeys: actionKeys };
}
export function createActionsReducer(namespace, computeActionId) {
    const actionKeys = {
        START: `${namespace.toUpperCase()}/START`,
        PENDING: `${namespace.toUpperCase()}/PENDING`,
        FINISH: `${namespace.toUpperCase()}/FINISH`,
        ERROR: `${namespace.toUpperCase()}/ERROR`,
        CLEAN: `${namespace.toUpperCase()}/CLEAN`,
    };
    const actions = createActions(actionKeys, computeActionId);
    const initialState = {};
    const reducer = (state = initialState, action) => {
        let currentItem;
        switch (action.type) {
            case actionKeys.FINISH:
                currentItem = state[action.id] || {};
                return Object.assign(Object.assign({}, state), { [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.READY, errorMessage: "", content: action.payload }) });
            case actionKeys.CLEAN:
                const _a = state, _b = action.id, deletedItem = _a[_b], cleanedState = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return cleanedState;
            case actionKeys.ERROR:
                currentItem = state[action.id] || {};
                return Object.assign(Object.assign({}, state), { [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.ERROR, errorMessage: action.payload, content: "" }) });
            case actionKeys.PENDING:
                currentItem = state[action.id] || {};
                return Object.assign(Object.assign({}, state), { [action.id]: Object.assign(Object.assign({}, currentItem), { status: ItemStatus.PENDING, errorMessage: "", content: "" }) });
            default:
                return state;
        }
    };
    return { actions, reducer, actionKeys };
}
function createActions(ActionKeys, computeActionId) {
    const startAction = (config, payload) => ({
        type: ActionKeys.START,
        config,
        payload,
    });
    const setActionError = (config, payload) => {
        const id = computeActionId(config);
        return {
            type: ActionKeys.ERROR,
            config,
            id,
            payload,
        };
    };
    const setAction = (config, payload) => {
        const id = computeActionId(config);
        return {
            type: ActionKeys.FINISH,
            config,
            id,
            payload,
        };
    };
    const setActionPending = (config) => {
        const id = computeActionId(config);
        return {
            type: ActionKeys.PENDING,
            id,
        };
    };
    const cleanStatus = (config) => {
        const id = computeActionId(config);
        return {
            type: ActionKeys.CLEAN,
            id,
        };
    };
    const actions = {
        [`start`]: startAction,
        [`setError`]: setActionError,
        [`setPending`]: setActionPending,
        [`setResponse`]: setAction,
        [`cleanStatus`]: cleanStatus,
    };
    return actions;
}
export function createSelectors(computeActionId) {
    function getResponse(state, config) {
        const id = computeActionId(config);
        return state[id] && state[id].content;
    }
    function getStatus(state, config) {
        const id = computeActionId(config);
        return state[id] && state[id].status;
    }
    function getError(state, config) {
        const id = computeActionId(config);
        const item = state[id] || { errorMessage: null };
        return item.errorMessage;
    }
    const selectors = {
        [`getResponse`]: getResponse,
        [`getStatus`]: getStatus,
        [`getError`]: getError,
    };
    return selectors;
}
export function actionMiddleware(ActionKeys, computeActionUrl, computeBodyContent, setAction, setActionError, setActionPending) {
    const performActionEpic = (action$, _, { ajax }) => action$.ofType(ActionKeys.START).mergeMap((action) => ajax(Object.assign(Object.assign({}, computeActionUrl(action.config)), { responseType: "json", body: computeBodyContent(action.payload), headers: { "Content-Type": "application/json" } }))
        .map((response) => setAction(action.config, response))
        .catch((error) => Observable.of(setActionError(action.config, getErrorMessage(error))))
        .startWith(setActionPending(action.config)));
    const middleware = [performActionEpic];
    return middleware;
}
//# sourceMappingURL=action.js.map